export enum TICKET_STATUS_CODE {
  UNREAD = 0,
  READ = 1,
  CLOSED = 2,
}

export const TICKET_STATUS = {
  [TICKET_STATUS_CODE.READ]: "جواب داده شده",
  [TICKET_STATUS_CODE.UNREAD]: "خوانده نشده",
  [TICKET_STATUS_CODE.CLOSED]: "بسته شده"
};

export const TICKET_COLOR = {
  [TICKET_STATUS_CODE.READ]: "success",
  [TICKET_STATUS_CODE.UNREAD]: "warning",
  [TICKET_STATUS_CODE.CLOSED]: "danger"
};

export enum TICKET_MESSAGE_OWNER_CODE {
  USER = 0,
  OPERATOR = 1,
}

export const TICKET_MESSAGE_OWNER = {
  [TICKET_MESSAGE_OWNER_CODE.USER]: "شما",
  [TICKET_MESSAGE_OWNER_CODE.OPERATOR]: "اپراتور"
};


export enum DEPARTMENT_CODE {
  technical = 0, marketing = 1, finance = 2
}

export const DEPARTMENT = {
  [DEPARTMENT_CODE.technical]: "بخش فنی",
  [DEPARTMENT_CODE.marketing]: "بخش بازاریابی",
  [DEPARTMENT_CODE.finance]: "بخش مالی"
};


export enum PAYMENT_STATUS_CODE {
  failed = "failed",
  waiting = "waiting",
  settled = "settled",
  success = "success",
}

export const PAYMENT_STATUS = {
  [PAYMENT_STATUS_CODE.success]: "موفق",
  [PAYMENT_STATUS_CODE.failed]: "ناموفق",
  [PAYMENT_STATUS_CODE.settled]: "تایید شده",
  [PAYMENT_STATUS_CODE.waiting]: "در انتظار پرداخت"
};

export const PAYMENT_STATUS_COLOR = {
  [PAYMENT_STATUS_CODE.success]: "info",
  [PAYMENT_STATUS_CODE.failed]: "danger",
  [PAYMENT_STATUS_CODE.settled]: "success",
  [PAYMENT_STATUS_CODE.waiting]: "warning"
};

export enum CAMPAIGN_STATUS_CODE {
  PENDING = 0,
  APPROVED = 1,
  REJECTED = 2,
  BANNED = 3,
}

export const CAMPAIGN_STATUS = {
  [CAMPAIGN_STATUS_CODE.BANNED]: "بسته شده",
  [CAMPAIGN_STATUS_CODE.REJECTED]: "رد شده",
  [CAMPAIGN_STATUS_CODE.APPROVED]: "تایید شده",
  [CAMPAIGN_STATUS_CODE.PENDING]: "در انتظار تایید"
};

export const CAMPAIGN_STATUS_COLOR = {
  [CAMPAIGN_STATUS_CODE.BANNED]: "danger",
  [CAMPAIGN_STATUS_CODE.REJECTED]: "danger",
  [CAMPAIGN_STATUS_CODE.APPROVED]: "success",
  [CAMPAIGN_STATUS_CODE.PENDING]: "warning"
};
